import React from "react";
import s from "./index.css";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import html2canvas from "html2canvas";
import SelectLogo from "../components/SelectLogo";
import logo from "../components/image/logo-680.png";
import { convertCanvasToImage, saveFile, toThousands } from "../../../utils";

import Button from "../components/Button";
import TooltipDrawer from "../components/TooltipDrawer";
import Form from "./Form";


function formatThousands(event) {
  if (event.target.innerText) {
    event.target.innerText = event.target.innerText
      .replace(/(\d),(\d)/g, "$1$2")
      .replace(/(\d)(?=(\d{3}\D?)+(\D|$))/g, "$1,");
  }
}

class P42 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataset: []
    };
  }
  // 截图并下载
  captureAndDownload = () => {
    // 通过class选择器获取所有要截图的div
    const divs = document.querySelectorAll(".conBox");
    const w = divs.offsetWidth;
    const h = divs.offsetHeight;

    Array.from(divs).forEach((div, index) => {
      html2canvas(div, {
        useCORS: true,
        scale: 2, // 将画布的尺寸放大到原始尺寸的两倍
        logging: false,
        foreignObjectRendering: true,
      }).then((canvas) => {
        // const link = document.createElement("a");
        // link.download = `周榜-${index + 1}.png`;
        // link.href = canvas.toDataURL("image/png");
        const src = convertCanvasToImage(canvas).src;
        saveFile(src, `周榜-${index + 1}`);

        // link.click();
      });
    });
  };

  render() {
    const { dataset } = this.state;
    return (
      <div className={s.appBox}>
        <Button
          type="primary"
          onClick={this.captureAndDownload}
          style={{ margin: "10px 10px ", display: "inline" }}
        >
          下载
        </Button>

        <TooltipDrawer
          formContent={
            <Form onChange={(values) => this.setState({ ...values })} />
          }
        >
          <div className={s.InnerBox}>
            {/* 添加特定class用于选择 */}
            {dataset.length > 0 &&
              dataset.map((item, index) => {
                return (
                  <div
                    className="screenshot-target"
                    style={{
                      border: "2px dashed #ccc",
                      padding: "20px",
                      margin: "10px 0",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <div
                      className="conBox"
                      style={{
                        width: "680px",
                        height: "auto",
                        backgroundColor: "#ededed",
                        padding: "17px 50px",
                        boxSizing: "border-box",
                      }}
                    >
                      <div className={s.headerBox}>
                        <img className={s.headerImage} src={logo}></img>
                        <div className={s.headerNo}>
                          <div contentEditable className={s.headerNo_1}>
                            周榜/
                          </div>
                          <div contentEditable className={s.headerNo_2}>
                            No.{index + 1}
                          </div>
                        </div>
                      </div>
                      <div className={s.content}>
                        <div className={s.brandLogoBox}>
                          {/* <SelectLogo className={s.brandLogo} /> */}
                          <img
                            crossorigin="anonymous"
                            className={s.logoImg}
                            // src={`https://corsproxy.io/?http://back.dbrank.net/digitalAssets/resources/img/LOGO/${item[26]}.png`}
                            src={`http://back.dbrank.net/digitalAssets/resources/img/LOGO/${item[26]}.png`}
                            // src={`https://dbrank.net/digitalAssets/resources/img/LOGO/${item[26]}.png`}
                            alt=""
                          />
                        </div>

                        <div className={s.content_box1}>
                          <div className={s.content_box1INner}>
                            <div className={s.content_box1_textBox}>
                              <div contentEditable>案例编号</div>
                              <div contentEditable spellCheck="false">
                                {item[0]}
                              </div>
                            </div>
                            <div className={s.content_box1_textBox}>
                              <div contentEditable>案例名称</div>
                              <div
                                contentEditable
                                spellCheck="false"
                                style={{ fontWeight: "bold" }}
                              >
                                {item[1]}
                              </div>
                            </div>
                            <div  className={s.content_box1_textBox}>
                              <div contentEditable>监测窗口</div>
                              <div contentEditable>{item[27]}</div>
                            </div>
                          </div>
                        </div>

                        <div className={s.content_box2}>
                          <div className={s.content_box2_title} contentEditable>
                            案例介绍
                          </div>
                          <div className={s.content_box2_inner} contentEditable spellCheck="false">
                            5月22日晚，小米举办15周年战略新品发布会，主题为“新起点”。会上，历经多年研发的第二代3nm工艺“玄戒01”芯片惊艳亮相。首发机型小米15S
                            Pro全面升级，小米平板7Ultra定位高端，首款SUV车型YU7也首次登场，彰显了小米未来的技术布局。
                          </div>
                        </div>

                        <div className={s.content_box3}>
                          <div className={s.content_box3_tag1}>
                            <div contentEditable>传播效果价值</div>
                            <div contentEditable onBlur={formatThousands}>
                              {toThousands(item[2])}
                              <span
                                style={{
                                  paddingLeft: "2px",
                                  fontSize: "14px",
                                  fontStyle: "italic",
                                }}
                                contentEditable
                              >
                                DB
                              </span>
                            </div>
                          </div>
                          <div className={s.content_box3_tag2}>
                            <div contentEditable>内容总条数</div>
                            <div contentEditable onBlur={formatThousands}>
                              {toThousands(Number(item[9]) + Number(item[10]))}
                              <span
                                style={{ paddingLeft: "2px", fontSize: "20px" }}
                                contentEditable
                              >
                                条
                              </span>
                            </div>
                          </div>
                          <div className={s.content_box3_tag3}>
                            <div contentEditable>内容传播度</div>
                            <div contentEditable>
                              {item[5]}
                              {/* <span
                                style={{ paddingLeft: "2px" }}
                                contentEditable
                              >
                                %
                              </span> */}
                            </div>
                          </div>
                        </div>

                        <div className={s.content_box4}>
                          <div className={s.content_box4_tag1}>
                            <div contentEditable>用户参与度</div>
                            <div contentEditable>
                              <span
                                style={{ fontSize: "30px", fontWeight: "bold" }}
                              >
                                {item[7]}
                              </span>
                              {/* <span
                                style={{ paddingLeft: "5px" }}
                                contentEditable
                              >
                                %
                              </span> */}
                            </div>
                          </div>
                          <div className={s.content_box4_tag2}>
                            <div contentEditable>全网好感度</div>
                            <div contentEditable>
                              <span
                                style={{ fontSize: "30px", fontWeight: "bold" }}
                              >
                                {item[8]}
                              </span>
                              {/* <span
                                style={{ paddingLeft: "5px" }}
                                contentEditable
                              >
                                %
                              </span> */}
                            </div>
                          </div>
                        </div>

                        <div className={s.content_box5}>
                          <div className={s.content_box5_tag1}>
                            <div contentEditable>传播引爆度</div>
                            <div contentEditable>
                              {item[17]}
                              {/* <span
                                style={{ paddingLeft: "5px" }}
                                contentEditable
                              >
                                %
                              </span> */}
                            </div>
                          </div>
                          <div className={s.content_box5_tag2}>
                            <div contentEditable>TOP10内容引爆力合计</div>
                            <div contentEditable onBlur={formatThousands}>
                              {toThousands(item[19])}
                              <span
                                style={{
                                  paddingLeft: "5px",
                                  // fontSize: "8px",
                                  fontStyle: "italic",
                                }}
                                contentEditable
                              >
                                DB
                              </span>
                            </div>
                          </div>
                          <div className={s.content_box5_tag3}>
                            <div contentEditable>单条内容引爆力均值</div>
                            <div contentEditable onBlur={formatThousands}>
                              {toThousands(item[24])}
                              <span
                                style={{
                                  paddingLeft: "5px",
                                  // fontSize: "8px",
                                  fontStyle: "italic",
                                }}
                                contentEditable
                              >
                                DB
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className={s.content_box6} contentEditable>
                          <span style={{ fontWeight: "bold" }}>案例类型:</span>{" "}
                              {item[28]}
                        </div>
                      </div>
                      <div className={s.content_text1} contentEditable>
                        <span style={{ fontWeight: "bold" }}>[数据来源]</span>{" "}
                        覆盖新闻媒体类(中央级媒体、泛财经媒体、行业媒体、大众媒体等)+网络资讯类(今日头条、一点资讯、腾讯新闻等网站
                        /APP)+社交媒体 (微博、知乎)+
                        自媒体平台(微信号、头条号、百家号等)+消费社区类(小红书、什么值得买等)+短视频类
                        (抖音、快手等)
                      </div>
                      <div className={s.content_text2} contentEditable>
                        <span style={{ fontWeight: "bold" }}>[研究方法]</span>{" "}
                        基于『数字品牌榜』专有计算模型得出。
                      </div>

                      <div className={s.bootomLogoBox}>
                        <div className={s.bootomLogo}></div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </TooltipDrawer>
      </div>
    );
  }
}

// export default P43;
export default withStyles(s)(P42);



// WEBPACK FOOTER //
// src/routes/visualChart/P42/index.js